export default {
  mtm: '0xd8b69a282b928d112ed3c4ca098991ea0aac27cc74aeb67f8db036db1cabf3e7',
  mtmLegacy: '0xb7865569c3b81a4ea294ab1f2c906a31d5420c017399fcb111e0277c116cc644',
  mtmFantom: '0x1739adae5d473e677d751034546d7b4e4f656e8969af74781574a09b7fe65987',
}
